import { initSplitApi } from './init'
import * as q from './elastic-query'

export const privateDBAPI = initSplitApi.injectEndpoints({
    reducerPath: 'privateDB',
    endpoints: (builder) => ({
        assignTire: builder.mutation({
            query: (body) => {
                return {
                    url: `https://91aoetjab3.execute-api.us-west-2.amazonaws.com/prod/notification/tire/assigned`,
                    method: 'POST',
                    body: body,
                    service: 'twilio'
                };
            },
            providesTags: ['assignTire']
        }),
        privateDBCreate: builder.mutation({
            query: (body) => {
                return {
                    url: `privatedb/_doc/${body.id}`,
                    method: 'PUT',
                    service: 'elastic',
                    body
                };
            },
            providesTags: ['privateDBDetails', 'privateDBList']
        }),
        privateDBEdit: builder.mutation({
            query: (body) => {
                return {
                    url: `privatedb/_update/${body.doc.id}`,
                    method: 'POST',
                    service: 'elastic',
                    body
                };
            },
            providesTags: ['privateDBDetails', 'privateDBList']
        }),
        privateDBDelete: builder.mutation({
            query: (body) => {

                return {
                    url: `privatedb/_doc/${body.id}`,
                    method: 'DELETE',
                    service: 'elastic'
                };
            },
            providesTags: ['privateDBDetails', 'privateDBList']
        }),
        privateDBList: builder.query({
            query: (params) => ({
                url: `privatedb/_search`,
                method: 'POST',
                body: q.getList(params.criteria),
                service: 'elastic'
            }),
            transformResponse: (response, meta, arg) => {
                if (response?.hits?.hits?.length > 0) {
                    var r = response;
                    return r
                }
            },
            providesTags: ['privateDBList']
        }),
        privateDBQList: builder.query({
            query: (params) => ({
                url: `privatedb/_search`,
                method: 'POST',
                body: params.q,
                service: 'elastic'
            }),
            transformResponse: (response, meta, arg) => {

                if (response?.hits?.hits?.length > 0) {
                    var r = response;
                    return r
                }
            },
            providesTags: ['privateDBList']
        }),

        privateDBDetails: builder.query({
            query: (params) => ({
                url: `privatedb/_search`,
                method: 'POST',
                body: q.getDetails(params.id),
                service: 'elastic'
            }),
            transformResponse: (response, meta, arg) => {

                if (response?.hits?.hits?.length > 0) {
                    return response.hits.hits[0]._source;
                }
            },
            providesTags: ['privateDBDetails']
        }),
    }),

    overrideExisting: false
})

export const {
    usePrivateDBCreateMutation,
    usePrivateDBDeleteMutation,
    usePrivateDBEditMutation,
    usePrivateDBDetailsQuery,
    usePrivateDBQListQuery,
    usePrivateDBListQuery,
    useAssignTireMutation
} = privateDBAPI